import React from 'react';
import { Grid } from '@mui/material';
import CustomAccordion from '../ui/CustomAccordion';
import InfoField from './InfoField';
import { getNestedProperty } from '../utils';

interface PersonalInformationProps {
  profile: Record<string, any>;
  fieldConfigs?: any;
  headerText?: string;
}

const PersonalInformationSection: React.FC<PersonalInformationProps> = ({
  profile,
  fieldConfigs,
  headerText,
}) => {
  const [expanded, setExpanded] = React.useState(true);

  const defaultFields = [
    { key: 'firstName', label: 'First Name' },
    { key: 'lastName', label: 'Last Name' },
    { key: 'dob', label: 'Date of Birth' },
    { key: 'gender', label: 'Gender' },
    { key: 'email', label: 'Email' },
    { key: 'phoneNumber', label: 'Phone Number' },
    { key: 'address', label: 'Address' },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State' },
    { key: 'zipcode', label: 'Zipcode' },
  ];

  const fields = fieldConfigs
    ? Array.isArray(fieldConfigs)
      ? fieldConfigs.map((config: any) => ({
          key: config.fields.ExpandedViewItemKey.value,
          label: config.fields.ExpandedViewItemLabel.value,
        }))
      : defaultFields
    : defaultFields;

  return (
    <CustomAccordion
      title={headerText || 'Personal Information'}
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      sx={{
        mt: 1,
        '& .MuiAccordionSummary-root': {
          minHeight: '40px',
          py: 0.5,
        },
        '& .MuiAccordionSummary-root.Mui-expanded': {
          minHeight: '40px',
          py: 0.5,
        },
        '& .MuiAccordionSummary-content': {
          margin: '0 !important',
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
          margin: '0 !important',
        },
      }}
      detailsSx={{ py: 1, px: 2 }}
    >
      <Grid container spacing={1.5}>
        {fields.map((field, index) => (
          <Grid item xs={12} sm={6} md={3} key={field.key || index}>
            <InfoField label={field.label} value={getNestedProperty(profile, field.key)} />
          </Grid>
        ))}
      </Grid>
    </CustomAccordion>
  );
};

export default PersonalInformationSection;
